import React, {Component} from 'react';
import classNames from 'classnames';

import UploadHandler from '../helpers/UploadHandler';
import UploadMedia from './UploadMedia.jsx';
import Loader from './Loader.jsx';
import Options from './Options.jsx';

//**********************
// Uploader Mask Element
// *********************
// Handles visual representation of uploading media. Renders proper SVG due to current upload state
// Component passes AJAX handling to external helper class (UploadHandler) and communicates with it
// via proper callbacks
// *********************
export default class UploaderMask extends Component {
    constructor() {
        super();
        this.state = {
            percent: 0,
            size: 0,
            uploaded: 0,
            response: null
        };
        this.UploadHandler = {};
    }

    componentDidMount() {
        const {filter, id, reference, path, hash} = this.props;
        this.UploadHandler = new UploadHandler(filter, reference, path, null, id, hash);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.reference !== this.props.reference) {
            const { filter, reference, path, hash } = nextProps;
            this.UploadHandler.update(filter, reference, path, hash)
        }

    }

    handleCrop() {
        if (!this.props.fetchedCropData) {
            this.UploadHandler.getCropValues(::this.handleCropDataSuccess);
        } else {
            return this.props.handleCropPopup();
        }
    }

    // Upload Action
    handleFileUpload(formData) {
        this.props.handleLoaderAndMask(true);
        this.UploadHandler.setNewImageToSend(formData);
        this.UploadHandler.postImage(::this.handleProgress, ::this.handleUploadedImage, ::this.handleUploadedError);
    }

    // Callback actions
    handleProgress(data) {
        this.setState({
            ...this.state, ...data
        })
    }

    handleCropDataSuccess(data) {
        this.props.onSaveNewCropSettings(data);
        this.props.handleCropPopup();
    }

    handleDelete() {
        this.UploadHandler.deleteImage(()=> {
            this.props.onDelete()
        });
    }

    // Loader animations
    handleUploadedImage(data) {
        const _this = this;

        this.setState({
            ...this.state,
            response: "success"
        });

        setTimeout(()=> {
            _this.handleActivateMask(false);
        }, 1500);

        // Set Loader to false and reset data for upload
        setTimeout(()=> {
            _this.props.handleLoader(false);

            // reset uploading data
            _this.setState({
                percent: 0,
                size: 0,
                uploaded: 0,
                response: null
            });

            _this.props.onUpload(data);
        }, 2000)
    }

    handleUploadedError() {
        const _this = this;

        this.setState({
            ...this.state,
            response: "error"
        });

        setTimeout(()=> {
            _this.handleActivateMask(false);
        }, 1500);

        // Set Loader to false and reset data for upload
        setTimeout(()=> {
            _this.props.handleLoader(false);

            // reset uploading data
            _this.setState({
                percent: 0,
                size: 0,
                uploaded: 0,
                response: null
            });
        }, 2000)
    }

    // Mask Actions
    handleActivateMask(value) {
        this.props.handleMask(value);
    }

    render() {
        const {loading, path, cropping, uploaderType, activeMask} = this.props;
        const uploadVisibility = loading ? {display: 'none'} : {display: 'block'};
        const maskClasses = classNames({
            'uploader-mask': true,
            'active-upload-mask': activeMask,
            'uploaded': path !== null && !loading

        });
        return (
        <div className={maskClasses}>
            {(()=> {
                if (path === null) {
                    return (
                    <div className="uploader-mask__container">
                        <UploadMedia style={uploadVisibility}
                                     cropping={cropping}
                                     activateMask={::this.handleActivateMask}
                                     onFileChange={::this.handleFileUpload}
                        />
                    </div>
                    )
                } else {
                    if (!loading) {
                        return (
                        <div className="upload-options__container">
                            <Options cropping={cropping}
                                     uploaderType={uploaderType}
                                     handleCrop={::this.handleCrop}
                                     activateMask={::this.handleActivateMask}
                                     onFileChange={::this.handleFileUpload}
                                     handleDelete={::this.handleDelete}
                            />
                        </div>
                        );
                    }
                }
            })()}
            {(()=> {
                if (loading) {
                    return (<div className="uploader-mask__container">
                        <Loader size={this.state.size}
                                percent={this.state.percent}
                                uploaded={this.state.uploaded}
                                response={this.state.response}
                        />
                    </div>);
                }
            })()}
        </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/_app/react-components/MediaUploader/components/UploaderMask.jsx